import { Button, Col, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import axiosInstance from "../../../axiosInstance";
import "../../../css/newitempage.css"
import React, {Component} from 'react';
import { generateErrorMessage } from "../../helper";
class NewStage extends Component{
    constructor(){
        super();
        this.state = {
            name: "",
            display_name:"",
            in_group:0,
            errors:{
                name:false,
                display_name:false
            },
            modal:false,
            error_messages:{
                name_error_message:'გთხოვთ შეიყვანოთ მდგომარეობა',
                display_name_error_message:""
            },
            response : {
                isValid : false,
                isInValid:false,
                message : 'მდგომარეობა წარმატებით ჩაემატა'
            }
        }
    }
    onChange(event){
        this.setState(
            {[event.target.name]:event.target.value,
                errors:{
                    ...this.state.errors,
                    [event.target.name]:false 
                },
                response : {
                    isValid : false,
                    isInValid:false,
                    message : ''
                }
            }
        ) 
    }

    on_stage_added(data){
       
    }
    add_stage_btn_clicked(event){
        this.setState({
            response:{
                ...this.state.response,
                isInValid:false,
                isValid:false,
                message:''
            }
        })
        if(this.valid()){
            axiosInstance.post('/tickets/stages',{
                name : this.state.name,
                display_name: this.state.display_name,
                in_group:this.state.in_group
            })
            .then(response=>{
                this.setState({
                    response:{
                        ...this.state.response,
                        isValid:true,
                        message:response.data.message
                    }
                })
            })
            .catch(error => {
                if(error.response.status == 400 || error.response?.status == 422){
                    this.on_bad_request(error);
                }
            });
        }
    }

    valid(){
        var name = (this.state.name === "");
        var display_name = (this.state.display_name === ""); 
        if(name || display_name ){
            this.setState({
                errors:{
                    name:name,
                    display_name:display_name
                },
            })
            return false;
        }
        return true;
    }

    on_bad_request(error){
        let message = generateErrorMessage(error.response.data.errors)
        this.setState({
            response:{
                ...this.state.response,
                isInValid:true,
                message:message
            }
        })
    }
    render(){
        return (
            <div className = "content-main">
                <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Control
                                    type="text"
                                    name="stage"
                                    hidden = {true}
                                    isInvalid = {Boolean(this.state.response.isInValid)}
                                    isValid = {Boolean(this.state.response.isValid)}
                                    onChange = {null}
                                />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.response.message}
                            </Form.Control.Feedback>

                            <Form.Control.Feedback >
                                {this.state.response.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                </Form.Row>
                <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Label>სახელი ლათინურად</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    onChange = {(event)=>this.onChange(event)}
                                    isInvalid = {Boolean(this.state.errors.name)}
                                    value = {this.state.role}
                                />
                                <Form.Control.Feedback type="invalid" >
                                    {this.state.error_messages.name_error_message}
                                </Form.Control.Feedback>     
                        </Form.Group>
                </Form.Row>
                <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Label>სახელი გამოსაჩენი</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="display_name"
                                    onChange = {(event)=>this.onChange(event)}
                                    isInvalid = {Boolean(this.state.errors.display_name)}
                                    value = {this.state.role}
                                />
                                <Form.Control.Feedback type="invalid" >
                                    {this.state.error_messages.display_name_error_message}
                                </Form.Control.Feedback>     
                        </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group >
                        <Form.Check type="checkbox" label="in group" onChange={(e) => {
                            this.setState({
                                in_group: e.target.checked
                            })
                        }} />
                    </Form.Group>
                </Form.Row>
                <Link  to = "/stages"  id="btn-back" className="btn btn-dark" >უკან დაბრუნება</Link>
                <Button className="btn btn-success"  size="md" onClick={(event)=>this.add_stage_btn_clicked(event)}>დამატება</Button>
            </div>
        )
    }
}
export default NewStage